
import { useState } from 'react';
import SEOHead from '../../components/seo/SEOHead';

export default function DoctorsPage() {
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');

  const specialties = [
    { id: 'all', name: 'All Specialists' },
    { id: 'orthodontics', name: 'Orthodontics' },
    { id: 'surgery', name: 'Oral Surgery' },
    { id: 'endodontics', name: 'Endodontics' },
    { id: 'pediatrics', name: 'Pediatrics' },
    { id: 'periodontics', name: 'Periodontics' },
    { id: 'prosthodontics', name: 'Prosthodontics' }
  ];

  const doctors = [
    {
      id: 1,
      name: 'Dr. N. R. Shrinivaasan',
      title: 'M.D.S., Consultant Orthodontist',
      specialization: 'Orthodontics & Dentofacial Orthopedics',
      category: 'orthodontics',
      experience: '20+ Years',
      position: 'Professor & Head of Department, Orthodontics, Dhanalakshmi Srinivasan Dental College',
      education: [
        'M.D.S. - Orthodontics & Dentofacial Orthopedics',
        'Professor & Head of Department - Dhanalakshmi Srinivasan Dental College'
      ],
      expertise: [
        'Traditional Braces',
        'Clear Aligners',
        'Dentofacial Orthopedics',
        'Growth Modification',
        'Jaw Alignment',
        'Aesthetic Orthodontics'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-5-768x779.jpg',
      philosophy: 'Dr. Shrinivaasan believes in blending aesthetics with functional alignment to create balanced smiles that enhance both appearance and oral health.',
      achievements: [
        'Professor & Head of Orthodontics Department',
        'Expert in complex orthodontic cases',
        'Pioneer in aesthetic orthodontic treatments',
        'Published researcher in orthodontic journals'
      ],
      languages: ['English', 'Tamil', 'Hindi'],
      availability: 'Mon-Fri: 9:00 AM - 6:00 PM, Sat: 9:00 AM - 2:00 PM'
    },
    {
      id: 2,
      name: 'Dr. Sandhya',
      title: 'General & Cosmetic Dentist',
      specialization: 'General Dentistry & Cosmetic Procedures',
      category: 'general',
      experience: '15+ Years',
      position: 'Chief Dental Surgeon & Founder',
      education: [
        'BDS - Tamil Nadu Dr. M.G.R. Medical University',
        'Advanced Training in Cosmetic Dentistry'
      ],
      expertise: [
        'Cosmetic Dentistry',
        'Dental Veneers',
        'Teeth Whitening',
        'Smile Makeovers',
        'Restorative Dentistry',
        'General Dental Care'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/elementor/thumbs/sandhiya-q8ywhy4exkvzh53f4jl50qjghrfs6dlutl3rqdr8hy.jpg',
      philosophy: 'Dr. Sandhya specializes in restorative and aesthetic procedures like veneers, whitening, and smile makeovers, focusing on creating beautiful, natural-looking smiles.',
      achievements: [
        'Founder of The Tooth Doctor Clinic',
        'Expert in smile design and makeovers',
        'Over 3000+ successful cosmetic procedures',
        'Pioneer in aesthetic dentistry in Chennai'
      ],
      languages: ['English', 'Tamil', 'Hindi'],
      availability: 'Mon-Sat: 9:00 AM - 10:00 PM'
    },
    {
      id: 3,
      name: 'Dr. Shanmugasundaram',
      title: 'MDS, FIBOMS, MBA, FAOCMF (Germany)',
      specialization: 'Oral & Maxillofacial Surgery',
      category: 'surgery',
      experience: '18+ Years',
      position: 'Senior Oral & Maxillofacial Surgeon',
      education: [
        'MDS - Oral & Maxillofacial Surgery',
        'FIBOMS - Fellowship in Oral & Maxillofacial Surgery',
        'MBA - Hospital Management',
        'FAOCMF - Fellowship from Germany'
      ],
      expertise: [
        'Complex Extractions',
        'Reconstructive Surgery',
        'Facial Trauma Management',
        'Jaw Surgery',
        'Oral Pathology',
        'Implant Surgery'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/WhatsApp-Image-2023-07-07-at-11.13.28-AM-768x779.jpeg',
      philosophy: 'With international exposure and surgical expertise, Dr. Shanmugasundaram handles complex extractions, reconstructive surgery, and facial trauma with precision and care.',
      achievements: [
        'International fellowship from Germany',
        'Expert in complex maxillofacial surgeries',
        'Hospital management expertise',
        'Published researcher in oral surgery'
      ],
      languages: ['English', 'Tamil', 'German'],
      availability: 'Tue-Thu: 10:00 AM - 5:00 PM, Sat: 9:00 AM - 3:00 PM'
    },
    {
      id: 4,
      name: 'Dr. K. Dhanadivya',
      title: 'Consultant Periodontist',
      specialization: 'Periodontics & Implant Support',
      category: 'periodontics',
      experience: '12+ Years',
      position: 'Senior Lecturer, Department of Periodontics, Sri Ramachandra Dental College',
      education: [
        'MDS - Periodontics',
        'Senior Lecturer - Sri Ramachandra Dental College & Hospital, SRIHER'
      ],
      expertise: [
        'Gum Disease Treatment',
        'Implant Support Therapy',
        'Minimally Invasive Periodontal Therapy',
        'Gum Grafting',
        'Bone Regeneration',
        'Laser Periodontics'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-768x779.jpg',
      philosophy: 'Dr. Dhanadivya is committed to gum health, implant support, and minimally invasive periodontal therapy, ensuring long-term oral health.',
      achievements: [
        'Senior Lecturer at prestigious dental college',
        'Expert in minimally invasive techniques',
        'Specialist in implant periodontics',
        'Research publications in periodontal therapy'
      ],
      languages: ['English', 'Tamil'],
      availability: 'Mon-Wed-Fri: 2:00 PM - 7:00 PM, Sat: 10:00 AM - 4:00 PM'
    },
    {
      id: 5,
      name: 'Dr. Suthanraj A. K.',
      title: 'MDS (Oral & Maxillofacial Surgery)',
      specialization: 'Oral & Maxillofacial Surgery',
      category: 'surgery',
      experience: '14+ Years',
      position: 'Associate Professor, Karpaga Vinayaga Institute of Dental Sciences',
      education: [
        'BDS - Karpaga Vinayaga Institute of Dental Sciences',
        'MDS - Oral & Maxillofacial Surgery',
        'Associate Professor - Karpaga Vinayaga Institute'
      ],
      expertise: [
        'Jaw Surgery',
        'Trauma Management',
        'Oral Pathology',
        'Facial Reconstructive Surgery',
        'TMJ Disorders',
        'Dental Implants'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-2-768x779.jpg',
      philosophy: 'Dr. Suthanraj emphasizes jaw surgery, trauma management, oral pathology, and facial reconstructive work with academic excellence and clinical precision.',
      achievements: [
        'Associate Professor at renowned dental institute',
        'Expert in complex jaw surgeries',
        'Specialist in facial reconstruction',
        'Academic and clinical excellence'
      ],
      languages: ['English', 'Tamil', 'Malayalam'],
      availability: 'Mon-Thu: 9:00 AM - 6:00 PM, Sat: 10:00 AM - 4:00 PM'
    },
    {
      id: 6,
      name: 'Dr. S. Riyaz Mohammed',
      title: 'Periodontist & Oral Implantologist',
      specialization: 'Periodontics & Implantology',
      category: 'periodontics',
      experience: '10+ Years',
      position: 'Member - Indian Periodontal Society (IPS)',
      education: [
        'MDS - Periodontics',
        'Advanced Training in Implantology',
        'Member - Indian Periodontal Society'
      ],
      expertise: [
        'Periodontal Therapy',
        'Dental Implants',
        'Gum Surgery',
        'Bone Grafting',
        'Implant Maintenance',
        'Aesthetic Periodontics'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2024/09/WhatsApp-Image-2024-09-23-at-7.53.13-PM-150x150.jpeg',
      philosophy: 'Dr. Riyaz combines periodontal expertise with implantology to restore oral health and function, ensuring comprehensive care for complex cases.',
      achievements: [
        'Member of Indian Periodontal Society',
        'Expert in implant-supported restorations',
        'Specialist in aesthetic periodontics',
        'Advanced implantology training'
      ],
      languages: ['English', 'Tamil', 'Urdu'],
      availability: 'Tue-Thu-Sat: 10:00 AM - 6:00 PM'
    },
    {
      id: 7,
      name: 'Dr. S. Sathiyaseelan',
      title: 'MDS, Prosthodontist & Implantologist',
      specialization: 'Prosthodontics & Implant Dentistry',
      category: 'prosthodontics',
      experience: '16+ Years',
      position: 'Senior Lecturer, Sri Venkateswara Dental College, Chennai',
      education: [
        'MDS - Prosthodontics',
        'Senior Lecturer - Sri Venkateswara Dental College',
        'Advanced Implantology Certification'
      ],
      expertise: [
        'Prosthetic Dentistry',
        'Full Mouth Rehabilitation',
        'Implant-Supported Dentures',
        'Crown & Bridge Work',
        'Aesthetic Restorations',
        'Complex Prosthetics'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2024/09/WhatsApp-Image-2024-09-23-at-7.53.14-PM-150x150.jpeg',
      philosophy: 'Dr. Sathiyaseelan specializes in prosthetics, full mouth rehabilitation, and implant-supported dentures, focusing on restoring function and aesthetics.',
      achievements: [
        'Senior Lecturer at prestigious dental college',
        'Expert in full mouth rehabilitation',
        'Specialist in complex prosthetic cases',
        'Advanced implant prosthetics training'
      ],
      languages: ['English', 'Tamil'],
      availability: 'Mon-Wed-Fri: 9:00 AM - 9:00 PM'
    },
    {
      id: 8,
      name: 'Dr. Santhosh',
      title: 'Senior Consultant Oral & Maxillofacial Surgeon',
      specialization: 'Oral & Maxillofacial Surgery & Implantology',
      category: 'surgery',
      experience: '15+ Years',
      position: 'Senior Consultant Oral & Maxillofacial Surgeon',
      education: [
        'MDS - Oral & Maxillofacial Surgery',
        'Advanced Training in Implantology',
        'Fellowship in Facial Surgery'
      ],
      expertise: [
        'Wisdom Tooth Removal',
        'TMJ Disorders',
        'Trauma Management',
        'Zygoma Implants',
        'Jaw Tumors',
        'Facial Surgeries'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-07-at-9.35.59-AM-150x150.jpeg',
      philosophy: 'Dr. Santhosh is an expert in wisdom tooth removal, TMJ disorders, trauma management, zygoma implants, jaw tumors, and facial surgeries.',
      achievements: [
        'Senior consultant with extensive experience',
        'Expert in complex facial surgeries',
        'Specialist in TMJ disorder treatment',
        'Advanced trauma management skills'
      ],
      languages: ['English', 'Tamil', 'Telugu'],
      availability: 'Tue-Thu-Sat: 11:00 AM - 6:00 PM'
    },
    {
      id: 9,
      name: 'Dr. Aysha Mansoor',
      title: 'MDS Pedodontist (Child Specialist)',
      specialization: 'Pediatric Dentistry',
      category: 'pediatrics',
      experience: '8+ Years',
      position: 'Pediatric Dental Specialist',
      education: [
        'MDS - Pediatric & Preventive Dentistry',
        'Specialized Training in Child Psychology',
        'Behavior Management Certification'
      ],
      expertise: [
        'Pediatric Dental Care',
        'Preventive Dentistry',
        'Behavior Management',
        'Fluoride Treatments',
        'Dental Sealants',
        'Special Needs Dentistry'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-03-at-3.23.45-PM-150x150.jpeg',
      philosophy: 'Dr. Aysha is a gentle and caring specialist for children, focused on preventive pediatric care and behavior management to create positive dental experiences.',
      achievements: [
        'Specialist in pediatric behavior management',
        'Expert in treating anxious children',
        'Pioneer in child-friendly dental techniques',
        'Advocate for preventive pediatric care'
      ],
      languages: ['English', 'Tamil', 'Urdu'],
      availability: 'Mon-Fri: 2:00 PM - 8:00 PM, Sat: 9:00 AM - 9:00 PM'
    },
    {
      id: 10,
      name: 'Dr. Venkateswaran',
      title: 'MDH, PhD - Orthodontics & Dentofacial Orthopaedics',
      specialization: 'Orthodontics & Dentofacial Orthopaedics',
      category: 'orthodontics',
      experience: '22+ Years',
      position: 'Reader, Sri Ramachandra Dental College',
      education: [
        'MDH - Orthodontics & Dentofacial Orthopaedics',
        'PhD - Orthodontics',
        'Reader - Sri Ramachandra Dental College'
      ],
      expertise: [
        'Orthodontic Planning',
        'Growth Modification',
        'Facial Harmony',
        'Complex Orthodontics',
        'Dentofacial Orthopedics',
        'Research & Development'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-03-at-3.32.19-PM-150x150.jpeg',
      philosophy: 'Dr. Venkateswaran works on orthodontic planning, growth modification, and facial harmony, combining academic research with clinical excellence.',
      achievements: [
        'PhD in Orthodontics with research focus',
        'Reader at prestigious dental college',
        'Expert in growth modification techniques',
        'Published researcher in orthodontic journals'
      ],
      languages: ['English', 'Tamil'],
      availability: 'Mon-Wed-Fri: 10:00 AM - 5:00 PM'
    },
    {
      id: 11,
      name: 'Dr. S. Akshai',
      title: 'MDS - Conservative Dentistry & Endodontics',
      specialization: 'Conservative Dentistry & Endodontics',
      category: 'endodontics',
      experience: '9+ Years',
      position: 'Specialist in Conservative Dentistry & Endodontics',
      education: [
        'MDS - Conservative Dentistry & Endodontics',
        'Advanced Training in Microscopic Endodontics',
        'Certification in Minimally Invasive Dentistry'
      ],
      expertise: [
        'Root Canal Treatment',
        'Restorative Dentistry',
        'Minimally Invasive Treatments',
        'Tooth Preservation',
        'Microscopic Endodontics',
        'Aesthetic Restorations'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-04-at-7.37.48-PM-150x150.jpeg',
      philosophy: 'Dr. Akshai is an expert in root canals, restorative care, minimally invasive treatments, and preserving natural teeth with modern techniques.',
      achievements: [
        'Expert in preserving natural teeth',
        'Specialist in minimally invasive techniques',
        'Advanced microscopic endodontics training',
        'Focus on conservative treatment approaches'
      ],
      languages: ['English', 'Tamil'],
      availability: 'Tue-Thu-Sat: 9:00 AM - 6:00 PM'
    },
    {
      id: 12,
      name: 'Dr. M. Deepalakshmi',
      title: 'Senior Consultant Endodontist',
      specialization: 'Endodontics & Root Canal Therapy',
      category: 'endodontics',
      experience: '13+ Years',
      position: 'Senior Consultant Endodontist, Associated with Apollo Hospitals',
      education: [
        'MDS - Conservative Dentistry & Endodontics',
        'Senior Consultant - Apollo Hospitals',
        'Advanced Endodontic Training'
      ],
      expertise: [
        'Root Canal Therapy',
        'Endodontic Retreatment',
        'Microscopic Endodontics',
        'Pulp Therapy',
        'Endodontic Surgery',
        'Pain Management'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2024/09/passport-photo-150x150.jpg',
      philosophy: 'Dr. Deepalakshmi brings precision and modern techniques to root canal therapy, associated with Apollo Hospitals for excellence in endodontic care.',
      achievements: [
        'Senior Consultant at Apollo Hospitals',
        'Expert in complex endodontic cases',
        'Specialist in microscopic techniques',
        'Advanced pain management protocols'
      ],
      languages: ['English', 'Tamil', 'Hindi'],
      availability: 'Mon-Wed-Fri: 11:00 AM - 6:00 PM'
    },
    {
      id: 13,
      name: 'Dr. M. Mohamed Jubair Hashir',
      title: 'Endodontist & Root Canal Specialist',
      specialization: 'Endodontics & Micro-Endodontics',
      category: 'endodontics',
      experience: '7+ Years',
      position: 'Endodontist & Root Canal Specialist',
      education: [
        'MDS - Conservative Dentistry & Endodontics',
        'Specialized Training in Micro-Endodontics',
        'Advanced Root Canal Techniques'
      ],
      expertise: [
        'Micro-Endodontics',
        'Root Canal Retreatments',
        'Complex Root Canal Cases',
        'Endodontic Microsurgery',
        'Single Visit Root Canals',
        'Digital Endodontics'
      ],
      image: 'https://toothdoctor.in/wp-content/uploads/2025/08/WhatsApp-Image-2025-08-16-at-10.42.29-AM-150x150.jpeg',
      philosophy: 'Dr. Jubair specializes in micro-endodontics, retreatments, and complex root canal cases, utilizing the latest technology for precise treatment.',
      achievements: [
        'Specialist in micro-endodontic procedures',
        'Expert in complex retreatment cases',
        'Advanced digital endodontics training',
        'Focus on single-visit treatments'
      ],
      languages: ['English', 'Tamil', 'Urdu'],
      availability: 'Mon-Thu: 2:00 PM - 7:00 PM, Sat: 10:00 AM - 4:00 PM'
    }
  ];

  const filteredDoctors = activeFilter === 'all' 
    ? doctors 
    : doctors.filter(doctor => doctor.category === activeFilter);

  const openDoctorModal = (doctor) => {
    setSelectedDoctor(doctor);
  };

  const closeDoctorModal = () => {
    setSelectedDoctor(null);
  };

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Our Doctors - The Tooth Doctor Advanced Dental Care Centre",
    "description": "Meet our expert dental specialists including orthodontists, oral surgeons, endodontists, and more. Experienced dental professionals in Chennai.",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/doctors`,
    "mainEntity": {
      "@type": "MedicalOrganization",
      "name": "The Tooth Doctor - Advanced Dental Care Centre",
      "employee": [
        {
          "@type": "Person",
          "name": "Dr. Sandhya",
          "jobTitle": "General & Cosmetic Dentist",
          "worksFor": {
            "@type": "DentalClinic",
            "name": "The Tooth Doctor"
          }
        },
        {
          "@type": "Person", 
          "name": "Dr. N. R. Shrinivaasan",
          "jobTitle": "M.D.S., Consultant Orthodontist",
          "worksFor": {
            "@type": "DentalClinic",
            "name": "The Tooth Doctor"
          }
        }
      ]
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Our Doctors",
          "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/doctors`
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Our Doctors - The Tooth Doctor | Expert Dental Specialists in Chennai"
        description="Meet our expert dental specialists including orthodontists, oral surgeons, endodontists, and more. Experienced dental professionals providing quality care in Chennai."
        keywords="dental doctors Chennai, orthodontist, oral surgeon, endodontist, dental specialists, expert dentists Thiruverkadu"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/doctors`}
        ogTitle="Our Doctors - Expert Dental Specialists in Chennai"
        ogDescription="Meet our expert dental specialists providing quality dental care with years of experience and advanced training in Chennai."
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/doctors`}
        ogImage={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/og-doctors.jpg`}
        jsonLd={jsonLd}
      />
      {/* Hero Section */}
      <section 
        className="relative py-20 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(1, 43, 83, 0.8), rgba(1, 43, 83, 0.7)), url('https://readdy.ai/api/search-image?query=Professional%20dental%20team%20group%20photo%2C%20experienced%20dentists%20in%20white%20coats%2C%20modern%20dental%20clinic%20environment%2C%20welcoming%20healthcare%20professionals%2C%20team%20collaboration%2C%20medical%20expertise&width=1920&height=600&seq=doctors-hero&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#012B53]/90 to-[#012B53]/70"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">Meet Our Dental Specialists</h1>
          <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto mb-8">
            Expert care by experienced dentists across all specialties. Our dedicated team brings years of clinical experience, advanced training, and patient-centric compassion to each treatment.
          </p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-yellow-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-yellow-600 transition-colors text-lg whitespace-nowrap"
          >
            Book Appointment
          </button>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed">
              At The Tooth Doctor, we believe that exceptional dental care begins with a dedicated and highly skilled team. 
              Our specialists bring years of clinical experience, advanced training, and patient-centric compassion to each treatment. 
              Meet our doctors who make confident smiles possible.
            </p>
          </div>
        </div>
      </section>

      {/* Specialty Filters */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {specialties.map((specialty) => (
              <button
                key={specialty.id}
                onClick={() => setActiveFilter(specialty.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap ${
                  activeFilter === specialty.id
                    ? 'bg-[#012B53] text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-blue-50 hover:text-[#012B53] shadow-md'
                }`}
              >
                {specialty.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Doctors Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredDoctors.map((doctor) => (
              <div key={doctor.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="relative">
                  <img 
                    src={doctor.image} 
                    alt={doctor.name}
                    className="w-full h-80 object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-6 text-white">
                    <div className="flex items-center space-x-2 mb-2">
                      <i className="ri-time-line text-yellow-400"></i>
                      <span className="text-sm font-medium">{doctor.experience}</span>
                    </div>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{doctor.name}</h3>
                  <p className="text-[#012B53] font-semibold mb-2">{doctor.title}</p>
                  <p className="text-gray-600 mb-3 text-sm">{doctor.position}</p>
                  
                  <div className="mb-4">
                    <p className="text-gray-700 text-sm leading-relaxed">{doctor.philosophy}</p>
                  </div>
                  
                  <div className="mb-4">
                    <div className="flex flex-wrap gap-2">
                      {doctor.expertise.slice(0, 3).map((skill, index) => (
                        <span key={index} className="bg-blue-50 text-[#012B53] px-3 py-1 rounded-full text-xs font-medium">
                          {skill}
                        </span>
                      ))}
                      {doctor.expertise.length > 3 && (
                        <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-medium">
                          +{doctor.expertise.length - 3} more
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-1">
                      <i className="ri-calendar-line text-gray-400"></i>
                      <span className="text-xs text-gray-600">Available</span>
                    </div>
                    <button 
                      onClick={() => openDoctorModal(doctor)}
                      className="bg-[#012B53] text-white px-4 py-2 rounded-full font-semibold hover:bg-blue-700 transition-colors text-sm whitespace-nowrap"
                    >
                      View Profile
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Our Team */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose Our Team?</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Our commitment to excellence and patient care sets us apart</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-graduation-cap-line text-[#012B53] text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Board-Qualified Specialists</h3>
              <p className="text-gray-600">Each doctor is board-qualified, experienced, and committed to continuing education</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-microscope-line text-[#012B53] text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Advanced Technology</h3>
              <p className="text-gray-600">Use of advanced dental technologies and evidence-based protocols for optimal results</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-[#012B53] text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Cross-Disciplinary Collaboration</h3>
              <p className="text-gray-600">Collaborative approach among specialists ensures comprehensive treatment planning</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-[#012B53] text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Personalized Care</h3>
              <p className="text-gray-600">Treatments tailored to each patient with focus on comfort, safety, and long-term results</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-[#012B53] to-blue-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Book a Consultation with Your Specialist Today</h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Experience the difference that expert care makes. Our specialists are ready to help you achieve optimal oral health.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="bg-yellow-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-yellow-600 transition-colors whitespace-nowrap"
            >
              Book Appointment
            </button>
            <a 
              href="tel:+916369090441"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-[#012B53] transition-colors whitespace-nowrap"
            >
              Call Now: +91 6369090441
            </a>
            <a 
              href="https://wa.me/916369090441"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-green-700 transition-colors whitespace-nowrap"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      {/* Doctor Detail Modal */}
      {selectedDoctor && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <button 
                onClick={closeDoctorModal}
                className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center text-gray-600 hover:text-gray-900 z-10"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8">
                <div>
                  <img 
                    src={selectedDoctor.image} 
                    alt={selectedDoctor.name}
                    className="w-full h-96 object-cover object-top rounded-2xl mb-6"
                  />
                  
                  <div className="mb-6">
                    <h3 className="font-bold text-gray-900 mb-2">Availability:</h3>
                    <p className="text-gray-600 flex items-center">
                      <i className="ri-calendar-line text-[#012B53] mr-2"></i>
                      {selectedDoctor.availability}
                    </p>
                  </div>

                  <div className="mb-6">
                    <h3 className="font-bold text-gray-900 mb-2">Languages:</h3>
                    <div className="flex space-x-2">
                      {selectedDoctor.languages.map((lang, index) => (
                        <span key={index} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm">
                          {lang}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-2">{selectedDoctor.name}</h2>
                  <p className="text-[#012B53] font-semibold text-xl mb-2">{selectedDoctor.title}</p>
                  <p className="text-gray-600 mb-4">{selectedDoctor.position}</p>
                  
                  <div className="mb-6">
                    <h3 className="font-bold text-gray-900 mb-2">Philosophy &amp; Approach:</h3>
                    <p className="text-gray-600">{selectedDoctor.philosophy}</p>
                  </div>
                  
                  <div className="mb-6">
                    <h3 className="font-bold text-gray-900 mb-2">Education &amp; Qualifications:</h3>
                    <ul className="space-y-1">
                      {selectedDoctor.education.map((edu, index) => (
                        <li key={index} className="text-gray-600 flex items-start">
                          <i className="ri-graduation-cap-line text-[#012B53] mt-1 mr-2"></i>
                          {edu}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mb-6">
                    <h3 className="font-bold text-gray-900 mb-2">Areas of Expertise:</h3>
                    <div className="flex flex-wrap gap-2">
                      {selectedDoctor.expertise.map((skill, index) => (
                        <span key={index} className="bg-blue-50 text-[#012B53] px-3 py-1 rounded-full text-sm font-medium">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="mb-6">
                    <h3 className="font-bold text-gray-900 mb-2">Key Achievements:</h3>
                    <ul className="space-y-1">
                      {selectedDoctor.achievements.map((achievement, index) => (
                        <li key={index} className="text-gray-600 flex items-start">
                          <i className="ri-star-line text-yellow-500 mt-1 mr-2"></i>
                          {achievement}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <button 
                    onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                    className="w-full bg-[#012B53] text-white py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap"
                  >
                    Book Consultation with {selectedDoctor.name.split(' ')[1]}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
